import { api } from '@/lib/api';
import {
  SubmitSaleApplicationRequest,
  SubmitSaleApplicationResponse,
  SellerProfileResponse,
  SubmitSaleSetupRequest,
  SubmitSaleSetupResponse,
  GetPostSaleResponse,
} from '@/features/original-sale/types/sale.types';
import { getClientSessionOrThrow } from '@/lib/client-session-auth';

export async function submitSaleApplicationReq(
  data: SubmitSaleApplicationRequest,
): Promise<SubmitSaleApplicationResponse> {
  const { accessToken } = await getClientSessionOrThrow();

  const response = await api.post<SubmitSaleApplicationResponse>(
    '/api/v1/seller/profile/submit',
    data,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
    },
  );

  return response.data;
}

export async function getSellerProfileReq(): Promise<SellerProfileResponse> {
  const { accessToken } = await getClientSessionOrThrow();

  const response = await api.get<SellerProfileResponse>('/api/v1/seller/profile', {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

  return response.data;
}

export async function getPostSaleReq(postId: string): Promise<GetPostSaleResponse> {
  const { accessToken } = await getClientSessionOrThrow();

  const response = await api.get<GetPostSaleResponse>(`/api/v1/seller/posts/${postId}/sale`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

  return response.data;
}

export async function submitSaleSetupReq(
  postId: string,
  data: SubmitSaleSetupRequest,
): Promise<SubmitSaleSetupResponse> {
  const { accessToken } = await getClientSessionOrThrow();

  const response = await api.post<SubmitSaleSetupResponse>(
    `/api/v1/seller/posts/${postId}/sale-application`,
    data,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
    },
  );

  return response.data;
}

export async function updateSaleApplicationReq(
  postId: string,
  data: SubmitSaleSetupRequest,
): Promise<SubmitSaleSetupResponse> {
  const { accessToken } = await getClientSessionOrThrow();

  const response = await api.patch<SubmitSaleSetupResponse>(
    `/api/v1/seller/posts/${postId}/sale-application`,
    data,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
    },
  );

  return response.data;
}
